import React from "react";
import { Redirect } from "react-router-dom";
import { useStaffSession } from "../session/staffSession";

var REQUIRE_CAP = {
  vendorpay: "canOperateVendorPay",
  valet: "canOperateValet",
  cart: "canOperateCart",
  accreditation: "canManageAccreditation",
  admin: "isAdmin",
  accounts: "canManageAccounts",
  feedback: "canViewSiteFeedback",
  sponsors: "canViewSponsors"
};

/**
 * Blocks staff from ops modules they are not allowed to use.
 * Booking-analytics-only and committee cash desks are redirected home.
 */
const StaffModuleGate = function (props) {
  var session = useStaffSession();
  if (session.status === "loading" || session.status === "idle") {
    return null;
  }
  if (session.status === "unauthenticated") {
    return null;
  }
  if (session.caps.isBookingViewerOnly) {
    return <Redirect to="/staff/bookings" />;
  }
  var capKey = REQUIRE_CAP[props.require] || "";
  if (capKey && !session.caps[capKey]) {
    return <Redirect to={session.caps.canRecordCash ? "/staff/cash" : "/staff"} />;
  }
  return props.children;
};

export default StaffModuleGate;
